var React = require('react');

function RightArrowCarrusell (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.293031 1.15192C0.480558 0.964446 0.734866 0.859131 1.00003 0.859131C1.26519 0.859131 1.5195 0.964446 1.70703 1.15192L8.70703 8.15192C8.8945 8.33945 8.99982 8.59375 8.99982 8.85892C8.99982 9.12408 8.8945 9.37839 8.70703 9.56592L1.70703 16.5659C1.51843 16.7481 1.26583 16.8489 1.00363 16.8466C0.741433 16.8443 0.49062 16.7391 0.305212 16.5537C0.119804 16.3683 0.0146352 16.1175 0.0123568 15.8553C0.0100783 15.5931 0.110873 15.3405 0.293031 15.1519L6.58603 8.85892L0.293031 2.56592C0.10556 2.37839 0.000244141 2.12408 0.000244141 1.85892C0.000244141 1.59375 0.10556 1.33945 0.293031 1.15192Z"}));
}

RightArrowCarrusell.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17","fill":"none"};

module.exports = RightArrowCarrusell;

RightArrowCarrusell.default = RightArrowCarrusell;
